import { STUDENT_CERTIFICATES_RETRIEVED } from './student-certificates-actions';

const defaultState = {
    schoolType: null,
    allStudents: null,
    studentList: []
};

/**
 * Student Certificates Reducer
 *
 * Consumes STUDENT_CERTIFICATES_RETRIEVED action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - contains list of individual student certificates for a class
 *                     as well as total for class
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case STUDENT_CERTIFICATES_RETRIEVED:
        return action.payload;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/certificates/student-certificates-reducer.js